<template>
  <div class="product-container">
    <Bread
      first-name="产品中心"
      metertype="智慧水务"
      meter-name="温湿度采集仪"
    ></Bread>
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scope>
</style>
